
import router from "@/router";
import { defineComponent, onMounted, ref } from "vue";
export default defineComponent({
  name: "Wel",
  setup() {
    // Datas
    const noActivated = ref(false);
    const animationIn = ref(false);
    const animationOut = ref(false);
    // hooks
    onMounted(() => {
      animationOut.value = false;
      animationIn.value = true;
      setTimeout(() => {
        animationIn.value = false;
        animationOut.value = true;
      }, 4000);
      setTimeout(() => {
        // 直接登陆, 如果无账户则进入登陆注册页面
        router.push({
          path: "/home"
        });
      }, 5000);
    });
    return {
      noActivated,
      animationIn,
      animationOut
    };
  }
});
